function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  id: "03.-E---apm\\u0101c\\u012Bba---Atv\\u0113rta-nodarb\\u012Bba",
  transform: "translate(-338.000000, -939.000000)",
  fill: "#686C74",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(294.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Attached-files",
  transform: "translate(24.000000, 806.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "File-attached",
  transform: "translate(0.000000, 43.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "No.",
  transform: "translate(20.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2,0 L11,0 L11.061,0.013 L11.061,0.013 C11.1203333,0.0163333333 11.1783333,0.0254444444 11.2352963,0.0394444444 L11.32,0.064 C11.352,0.075 11.384,0.083 11.414,0.097 C11.4846667,0.129666667 11.5531111,0.167666667 11.6163704,0.214851852 L11.707,0.293 L17.707,6.293 C17.793,6.379 17.854,6.48 17.903,6.586 L17.921,6.63175 L17.921,6.63175 L17.936,6.679 C17.965,6.763 17.982,6.849 17.987,6.938 L18,7 L18,22 C18,23.0528636 17.1826921,23.9180289 16.1490673,23.994505 L16,24 L2,24 C0.947136364,24 0.0819710744,23.1826921 0.00549502254,22.1490673 L0,22 L0,2 C0,0.947136364 0.817307851,0.0819710744 1.85093266,0.00549502254 L2,0 Z M10,2 L2,2 L2,22 L16.002,22 L16,8 L11,8 C10.4865,8 10.064398,7.61457653 10.0067176,7.11675328 L10,7 L10,2 Z M14,18 L14,20 L4,20 L4,18 L14,18 Z M14,14 L14,16 L4,16 L4,14 L14,14 Z M14,10 L14,12 L4,12 L4,10 L14,10 Z M8,6 L8,8 L4,8 L4,6 L8,6 Z M12,3.414 L12,6 L14.586,6 L12,3.414 Z",
  id: "ic-file-24px"
})))))));

function SvgIcFile24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "24px",
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "326E4832-9A35-41D3-8B91-2E1146DDED57") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFile24Px);
export default __webpack_public_path__ + "static/media/ic-file-24px.e4cdd8b1.svg";
export { ForwardRef as ReactComponent };